import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Footer.scss';
import LazyImage from "./LazyImage";

const ICONS = {
  whatsapp: "/icons/whatsapp.webp",
  tiktok: "/icons/tiktok.webp",
  instagram: "/icons/instagram.webp",
  facebook: "/icons/facebook.webp",
};
const Footer = () => {
  const { t } = useTranslation();
  return (
  <footer className="footer">
    <div className="socials" role="navigation" aria-label="Social media">
      <a
        className="social social--phone"
        href="tel:+97144224469"
        aria-label="Call us"
        title="اتصل بنا"
      >
        <span role="img" aria-hidden="true">☎</span>
      </a>
      <a
        className="social social--whatsapp"
        href="https://wa.me/971527818944?text=Hello%20Shawarma%20Dose"
        aria-label="WhatsApp"
        target="_blank"
        rel="noopener noreferrer"
        title="تواصل عبر واتساب"
      >
        <LazyImage src={ICONS.whatsapp} alt="Whatsapp" />
      </a>
      <a
        className="social social--tiktok"
        href="https://www.tiktok.com/@shawarma.dose.dxb?is_from_webapp=1&sender_device=pc"
        aria-label="TikTok"
        target="_blank"
        rel="noopener noreferrer"
      >
        <LazyImage src={ICONS.tiktok} alt="Tiktok" />
      </a>
      <a
        
        className="social social--instagram"
        href="https://www.instagram.com/shawarama.dose.dxb"
        aria-label="Instagram"
        target="_blank"
        rel="noopener noreferrer"
      >
        {/* IG */}
         <LazyImage src={ICONS.instagram} alt="Instagram" />
      </a>
      <a
        className="social social--facebook"
        href="https://www.facebook.com/share/1CH7Ff16SM"
        aria-label="Facebook"
        target="_blank"
        rel="noopener noreferrer"
      >
         <LazyImage src={ICONS.facebook} alt="Facebook" />
      </a>
    </div>
    <p className="footer-links">
      <Link to="/contact">{t("footer.contactLink")}</Link>
      <span aria-hidden="true"> · </span>
      <Link to="/policies">{t("footer.policiesLink")}</Link>
    </p>
    <p>© {new Date().getFullYear()} Shawarma Dose. جميع الحقوق محفوظة.</p>
  </footer>
  );
};

export default Footer;
